import * as types from "../../constants";
import { ActionsOf, init } from "../utils";
import * as actions from "../actions-declarations/questions";
import {Question} from "../../models/Question";

export type QuestionActions = typeof actions;

export type QuesitonsType = {
  questions: Question[];
};

export default function reducer(
  state = init<QuesitonsType>({
    questions: [],
  }),
  actions: ActionsOf<QuestionActions>
): typeof state {
  switch (actions.type) {
    case types.FETCH_QUESTIONS:
      return {
        ...state,
        questions: actions.questions,
      };
    default:
      return state;
  }
}
